/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_Switchtoenglish2Inputs */

const en_language_switchtoenglish2 = /** @type {(inputs: Language_Switchtoenglish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to English`)
};

const fr_language_switchtoenglish2 = /** @type {(inputs: Language_Switchtoenglish2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to English`)
};

/**
* | output |
* | --- |
* | "Switch to English" |
*
* @param {Language_Switchtoenglish2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const language_switchtoenglish2 = /** @type {((inputs?: Language_Switchtoenglish2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_Switchtoenglish2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_language_switchtoenglish2(inputs)
	return fr_language_switchtoenglish2(inputs)
});
export { language_switchtoenglish2 as "language_switchToEnglish" }